/*
 * Copyright (c) Dito Technologies
 */

import {graphql} from "babel-plugin-relay/macro";
import {
    MusicPageStatus,
    UpdateMusicPageMutation$data,
    UpdateMusicPageMutation$variables
} from "./__generated__/UpdateMusicPageMutation.graphql";
import perform from "mutation/perform";

const mutation = graphql`
    mutation UpdateMusicPageMutation($input: MusicUpdatePageInput!) {
        music_update_page(input: $input) {
            page_id
        }
    }
`;

function UpdateMusicPage(pageId: string, status: MusicPageStatus): Promise<UpdateMusicPageMutation$data> {
    const variables: UpdateMusicPageMutation$variables = {
        input: {
            page_id: pageId,
            status: status
        }
    }
    return perform(mutation, variables)
}

export default UpdateMusicPage;